<template>
  <div
    class="text-[var(--foreground)] bg-[linear-gradient(109.63deg,var(--color-1)_3.67%,var(--color-2)_83.91%)] overflow-hidden relative"
    v-show="hydrated"
  >
    <WrOfficialPartnerHeader />
    <WrSecondHeader />
    <WrBreadCrumb class="mt-36 z-30 relative" />

    <div class="">
      <slot />
    </div>

    <section
      class="grid place-items-center z-10 relative pt-16 lg:pt-32 max-md:px-4 overflow-hidden"
      id="mask-section"
    >
      <LazyWrAnimatedImg />
    </section>
    <WrFooter />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
const hydrated = ref(false);
onMounted(() => {
  hydrated.value = true;
});
</script>
